"use strict";

const { String, Boolean } = require("../lib/types");
const { make } = require("../lib/build-spec");

module.exports = {
  generalReviewed: make(Boolean, "generalReviewed", "Reviewed and Negative"),
  generalWeightLoss: make(Boolean, "generalWeightLoss", "Weight Loss"),
  generalNightSweats: make(Boolean, "generalNightSweats", "Night Sweats"),
  generalFever: make(Boolean, "generalFever", "Fever"),
  generalInsomnia: make(Boolean, "generalInsomnia", "Insomnia"),
  generalOther: make(Boolean, "generalOther", "Other"),
  generalOtherText: make(String, "generalOtherText", "Other Text"),

  enteReviewed: make(Boolean, "enteReviewed", "Reviewed and Negative"),
  enteEpistaxis: make(Boolean, "enteEpistaxis", "Epistaxis"),
  enteTinnitus: make(Boolean, "enteTinnitus", "Tinnitus"),
  enteDysphagia: make(Boolean, "enteDysphagia", "Dysphagia"),
  enteSmellChanges: make(Boolean, "enteSmellChanges", "Smell Changes"),
  enteHearingChanges: make(Boolean, "enteHearingChanges", "Hearing Changes"),
  enteVisualChanges: make(Boolean, "enteVisualChanges", "Visual Changes"),
  enteTasteChanges: make(Boolean, "enteTasteChanges", "Taste Changes"),
  enteDoubleVision: make(Boolean, "enteDoubleVision", "Double Vision"),
  enteOther: make(Boolean, "enteOther", "Other"),
  enteOtherText: make(String, "enteOtherText", "Other Text"),

  endocrineReviewed: make(
    Boolean,
    "endocrineReviewed",
    "Reviewed and Negative"
  ),
  endocrineTemperature: make(
    Boolean,
    "endocrineTemperature",
    "Temperature Instability"
  ),
  endocrineOther: make(Boolean, "endocrineOther", "Other"),
  endocrineOtherText: make(String, "endocrineOtherText", "Other Text"),

  digestiveReviewed: make(
    Boolean,
    "digestiveReviewed",
    "Reviewed and Negative"
  ),
  digestiveBrbpr: make(Boolean, "digestiveBrbpr", "BRBPR"),
  digestiveReflux: make(Boolean, "digestiveReflux", "Reflux"),
  digestiveOther: make(Boolean, "digestiveOther", "Other"),
  digestiveOtherText: make(String, "digestiveOtherText", "Other Text"),

  cardiovascularReviewed: make(
    Boolean,
    "cardiovascularReviewed",
    "Reviewed and Negative"
  ),
  cardiovascularChestPain: make(
    Boolean,
    "cardiovascularChestPain",
    "Chest Pain"
  ),
  cardiovascularPalpitations: make(
    Boolean,
    "cardiovascularPalpitations",
    "Palpitations"
  ),
  cardiovascularFaintness: make(
    Boolean,
    "cardiovascularFaintness",
    "Faintness"
  ),
  cardiovascularOther: make(Boolean, "cardiovascularOther", "Other"),
  cardiovascularOtherText: make(
    String,
    "cardiovascularOtherText",
    "Other Text"
  ),

  allergiesReviewed: make(
    Boolean,
    "allergiesReviewed",
    "Reviewed and Negative"
  ),
  allergiesAnaphylaxis: make(Boolean, "allergiesAnaphylaxis", "Anaphylaxis"),
  allergiesOther: make(Boolean, "allergiesOther", "Other"),
  allergiesOtherText: make(String, "allergiesOtherText", "Other Text"),

  genitourinaryReviewed: make(
    Boolean,
    "genitourinaryReviewed",
    "Reviewed and Negative"
  ),
  genitourinaryIncontinence: make(
    Boolean,
    "genitourinaryIncontinence",
    "Incontinence"
  ),
  genitourinaryDysuria: make(Boolean, "genitourinaryDysuria", "Dysuria"),
  genitourinaryHematuria: make(Boolean, "genitourinaryHematuria", "Hematuria"),
  genitourinaryOther: make(Boolean, "genitourinaryOther", "Other"),
  genitourinaryOtherText: make(String, "genitourinaryOtherText", "Other Text"),

  hematologicReviewed: make(
    Boolean,
    "hematologicReviewed",
    "Reviewed and Negative"
  ),
  hematologicPetechia: make(Boolean, "hematologicPetechia", "Petechia"),
  hematologicExcessiveBleeding: make(
    Boolean,
    "hematologicExcessiveBleeding",
    "Excessive Bleeding"
  ),
  hematologicBruising: make(Boolean, "hematologicBruising", "Bruising"),
  hematologicOther: make(Boolean, "hematologicOther", "Other"),
  hematologicOtherText: make(String, "hematologicOtherText", "Other Text"),

  integumentaryReviewed: make(
    Boolean,
    "integumentaryReviewed",
    "Reviewed and Negative"
  ),
  integumentaryPruritus: make(Boolean, "integumentaryPruritus", "Pruritus"),
  integumentaryRashes: make(Boolean, "integumentaryRashes", "Rashes"),
  integumentaryLesions: make(Boolean, "integumentaryLesions", "Lesions"),
  integumentaryIncisions: make(Boolean, "integumentaryIncisions", "Incisions"),
  integumentaryOther: make(Boolean, "integumentaryOther", "Other"),
  integumentaryOtherText: make(String, "integumentaryOtherText", "Other Text"),

  mentalhealthReviewed: make(
    Boolean,
    "mentalhealthReviewed",
    "Reviewed and Negative"
  ),
  mentalhealthDifficultyConcentrating: make(
    Boolean,
    "mentalhealthDifficultyConcentrating",
    "Difficulty Concentrating"
  ),
  mentalhealthParanoia: make(Boolean, "mentalhealthParanoia", "Paranoia"),
  mentalhealthChangeInPersonality: make(
    Boolean,
    "mentalhealthChangeInPersonality",
    "Change in Personality"
  ),
  mentalhealthMania: make(Boolean, "mentalhealthMania", "Mania"),
  mentalhealthAgitation: make(Boolean, "mentalhealthAgitation", "Agitation"),
  mentalhealthIrritability: make(
    Boolean,
    "mentalhealthIrritability",
    "Irritability"
  ),
  mentalhealthHopelessness: make(
    Boolean,
    "mentalhealthHopelessness",
    "Hopelessness"
  ),
  mentalhealthSI: make(Boolean, "mentalhealthSI", "SI"),
  mentalhealthHI: make(Boolean, "mentalhealthHI", "HI"),
  mentalhealthLoneliness: make(Boolean, "mentalhealthLoneliness", "Loneliness"),
  mentalhealthPoorBodyImage: make(
    Boolean,
    "mentalhealthPoorBodyImage",
    "Poor Body Image"
  ),
  mentalhealthGrief: make(Boolean, "mentalhealthGrief", "Grief"),
  mentalhealthOther: make(Boolean, "mentalhealthOther", "Other"),
  mentalhealthOtherText: make(String, "mentalhealthOtherText", "Other Text"),

  musculoskeletalReviewed: make(
    Boolean,
    "musculoskeletalReviewed",
    "Reviewed and Negative"
  ),
  musculoskeletalStiffness: make(
    Boolean,
    "musculoskeletalStiffness",
    "Stiffness"
  ),
  musculoskeletalJointSwelling: make(
    Boolean,
    "musculoskeletalJointSwelling",
    "Joint Swelling"
  ),
  musculoskeletalDecreasedRangeOfMotion: make(
    Boolean,
    "musculoskeletalDecreasedRangeOfMotion",
    "Decreased Range of Motion"
  ),
  musculoskeletalEdema: make(Boolean, "musculoskeletalEdema", "Edema"),
  musculoskeletalOther: make(Boolean, "musculoskeletalOther", "Other"),
  musculoskeletalOtherText: make(
    String,
    "musculoskeletalOtherText",
    "Other Text"
  ),

  neurologicalReviewed: make(
    Boolean,
    "neurologicalReviewed",
    "Reviewed and Negative"
  ),
  neurologicalHeadache: make(Boolean, "neurologicalHeadache", "Headache"),
  neurologicalChangesInSpeech: make(
    Boolean,
    "neurologicalChangesInSpeech",
    "Changes in Speech"
  ),
  neurologicalSeizures: make(Boolean, "neurologicalSeizures", "Seizures"),
  neurologicalNumbness: make(Boolean, "neurologicalNumbness", "Numbness"),
  neurologicalWeakness: make(Boolean, "neurologicalWeakness", "Weakness"),
  neurologicalPoorBalance: make(
    Boolean,
    "neurologicalPoorBalance",
    "Poor Balance"
  ),
  neurologicalTremors: make(Boolean, "neurologicalTremors", "Tremors"),
  neurologicalOther: make(Boolean, "neurologicalOther", "Other"),
  neurologicalOtherText: make(String, "neurologicalOtherText", "Other Text"),

  respiratoryReviewed: make(
    Boolean,
    "respiratoryReviewed",
    "Reviewed and Negative"
  ),
  respiratoryCough: make(Boolean, "respiratoryCough", "Cough"),
  respiratorySputum: make(Boolean, "respiratorySputum", "Sputum"),
  respiratoryDOE: make(Boolean, "respiratoryDOE", "DOE"),
  respiratoryOther: make(Boolean, "respiratoryOther", "Other"),
  respiratoryOtherText: make(String, "respiratoryOtherText", "Other Text")
};
